import FlatThreeDot from "../icons/FlatThreeDot";

const ContentGroupSettingsButton = ({ onClick, className }) => (
    <div className={`content-group-settings-button cursor-pointer align-items-center justify-content-center ms-2 p-1 ${className}`} onClick={onClick}>
        <FlatThreeDot className="content-group-settings-icon"/>
    </div>
);

export { ContentGroupSettingsButton };